import { createContext, useContext } from 'react';

/**
 * Shared render context for Main-area tiles. Carries the values that come from
 * component-local hooks (focus state, viewport-derived flags, the current
 * render set) so the Stage / FeedStrip subcomponents don't have to drill them
 * into every tile. Values that live in the Redux store (own name, screen-share
 * flags, the videoMember) are read directly by the tiles from selectors.
 */
export interface MeetingTileContextValue {
    isCompact: boolean;
    /** Whether the pin control is offered on feeds (off in the compact dock). */
    pinControlEnabled: boolean;
}

const MeetingTileContext = createContext<MeetingTileContextValue | null>(null);

export const useMeetingTileContext = (): MeetingTileContextValue => {
    const context = useContext(MeetingTileContext);
    if (!context) {
        throw new Error(
            'useMeetingTileContext must be used within a MeetingTileContext.Provider',
        );
    }
    return context;
};

export default MeetingTileContext;
